import { render, staticRenderFns } from "./UserUsageGroupCoursesDialog.vue?vue&type=template&id=dc8c6cc0&"
import script from "./UserUsageGroupCoursesDialog.vue?vue&type=script&lang=ts&"
export * from "./UserUsageGroupCoursesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports